var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-navigation"},[_c('div',{staticClass:"page-title"},[_c('h2',{key:_vm.title,domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("subtitle")],2),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }